'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_RootNode(container, child) {
  this.zh = null;
  this.H2 = null;
  this.H3 = null;
  this.H2 = child;
  $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  if ((container === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Unable to mount Laminar RootNode into a null container. See https://laminar.dev/documentation#waiting-for-the-dom-to-load");
  }
  if ((!$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().Vn(container, document))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Unable to mount Laminar RootNode into an unmounted container. See https://laminar.dev/documentation#rendering");
  }
  this.H3 = container;
  this.W6();
}
export { $c_Lcom_raquo_laminar_nodes_RootNode as $c_Lcom_raquo_laminar_nodes_RootNode };
$p = $c_Lcom_raquo_laminar_nodes_RootNode.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_RootNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_RootNode() {
}
export { $h_Lcom_raquo_laminar_nodes_RootNode as $h_Lcom_raquo_laminar_nodes_RootNode };
$h_Lcom_raquo_laminar_nodes_RootNode.prototype = $p;
$p.xd = (function() {
  return this.zh;
});
$p.Od = (function(x$0) {
  this.zh = x$0;
});
$p.W6 = (function() {
  this.zh.NP();
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().qP(this, this.H2, (void 0));
});
$p.aV = (function() {
  return this.H3;
});
var $d_Lcom_raquo_laminar_nodes_RootNode = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_nodes_RootNode, "com.raquo.laminar.nodes.RootNode", ({
  iN: 1,
  bM: 1,
  cZ: 1
}));
export { $d_Lcom_raquo_laminar_nodes_RootNode as $d_Lcom_raquo_laminar_nodes_RootNode };
